import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import App from "./App"
import "./scss/index.scss"
import "./i18next"

if (process.env.NODE_ENV !== "development") {
  console.log = () => {}
}

ReactDOM.render(
  <Suspense fallback="loading">
    <App />
  </Suspense>,
  document.getElementById("root")
)
